import { SET_INVENTORY, LOGOUT, CLEAR_INVENTORY } from "../actions/type";

var initailState=[];

const inventory =( state = initailState , action) =>{
    switch (action.type) {
        case SET_INVENTORY:
            return [
                ...state,
                ...action.payload,
            ];
        case CLEAR_INVENTORY:
            return initailState;
        case LOGOUT:
            return initailState;
        default:
            return state;
    }
};

export default inventory;